<template>
  <Modal
    v-model="_value"
    width="500"
    title="ZT磁盘格式化"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="90">
      <FormItem prop="driverName" label="磁盘名称">
        <Select v-model="setDriverCardParams.disk" style="width: 220px;">
          <Option v-for="item in diskOptions" :value="item.name" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'


export default {
  name: 'ztsetdiskformattingmodal',
  components: {

  },
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setDriverCardParams: {
        id: null,
        disk: '硬盘',
      },

      diskOptions: [
        {name: '硬盘', value: 1},
        {name: 'SD1', value: 2},
        {name: 'SD2', value: 3},
        {name: 'USB', value: 4},
      ],
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    visibleChange (val) {
      if (val) {
        this.setDriverCardParams.id = this._initValue
        this.setDriverCardParams.disk = '硬盘'
      }
    },
    onCleanDriverCardParams () {
      this.setDriverCardParams.disk = '硬盘'
    },
    onSendDriverCardParams () {


      if (this.setDriverCardParams.disk == null) {
        this.$Message.error('硬盘名称不能为空')
        return
      }
      console.log('##_ZTTtsSet;磁盘格式化;磁盘名称='+this.setDriverCardParams.disk+',格式化$')
      let content = '#_ZTTtsSet;磁盘格式化;'
      if (this.setDriverCardParams.disk !=null && this.setDriverCardParams.disk != ''){
        content += '磁盘名称='+this.setDriverCardParams.disk + ','
      }
      content += '格式化$'
      console.log(content)

      this.$Modal.confirm({
        title: '添加支出项',
        content: '<p>是否确认格式化</p>',
        onOk: () => {
          store.dispatch('NetCommandServ_SendCommand', {
            params: { id: this._initValue, content: content, urgent: false }
          }).then(() => {
            this.$Message.success('发送成功')
          }).catch(err => {
            this.$Message.error(err)
          })
        },
        onCancel: () => {
        }
      })

    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
